import styled from 'styled-components'

type Props = {
	showArticles: boolean
}

export const Container = styled.div<Props>`
	height: 100vh;
	overflow: hidden;
	display: grid;
	grid-template: ${({ showArticles }) =>
		showArticles
			? `
		'header header' auto
		'articles main' 1fr
		/ minmax(200px, 270px) 1fr
	`
			: `
		'header' auto
		'main' 1fr
		/ 1fr
	`};

	@media only screen and (max-width: 750px) {
		grid-template:
			'header' auto
			'main' 1fr
			/ 1fr;
	}
`
